import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-button',
  template: `
    <div
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
      *ngIf="field.visible != null ? (!field.visible ? false : true) : true"
    >
      <button
        class="cs_botao {{ field.class }}"
        (click)="field.onClick()"
        [ngStyle]="field.style()"
        [disabled]="field.disabled"
        type="button"
      >
        <!-- Icone field.src -->
        <img *ngIf="field.src" class="button__icon" [src]="field.src" />
        <!---->
        {{ field.label }}
      </button>
    </div>
  `,
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() {}
  ngOnInit() {}
}
